import { render, staticRenderFns } from "./Prouni.vue?vue&type=template&id=458d3b10&scoped=true&"
import script from "./Prouni.vue?vue&type=script&lang=js&"
export * from "./Prouni.vue?vue&type=script&lang=js&"
import style0 from "./Prouni.vue?vue&type=style&index=0&id=458d3b10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458d3b10",
  null
  
)

export default component.exports